import Vue from 'vue'
import Router from 'vue-router'

const both = (name) => () => import(`@/views/${name}`);
Vue.use(Router);
var routes=[
	{
		path: '/',
		name: '首页',
		component: both("index"),
	},
	{
		path: '/search',
		name: '搜索',
		component: both("search"),
	},
	{
		path: '/course_list',
		name: '课程',
		component: both("course_list"),
	},
	{
		path: '/course_detail',
		name: '课程详情',
		component: both("course_detail"),
	},
	{
		path: '/user_detail',
		name: '我的积分',
		component: both("user_detail"),
	}
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/index.js